<template>
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header p-2">
        <h6 class="modal-title">
        <span  style="overflow-wrap: anywhere;">{{selectedJobInfo.slug_name?selectedJobInfo.data.slug_name:selectedJobInfo.data.file_name}}</span></h6>
        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
          <span aria-hidden="true"><cancel-icon class="close-icon mt-1" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
        </button>
      </div>
      <div class="modal-body">
          <div class="assets-details-in-metadata-manager">
                <ul>
                    <li v-if="Object.keys(selectedJobInfo).includes('job_id') &&
                    !['undefined',null].includes(selectedJobInfo.job_id) &&  selectedJobInfo.job_id.length > 0">
                        <div class="key-style">{{$t('Job Id')}}</div>
                        <div class="value-style">{{selectedJobInfo.job_id}}</div>
                    </li>
                    <li v-if="Object.keys(selectedJobInfo).includes('job_name') &&
                    !['undefined',null].includes(selectedJobInfo.job_name) &&  selectedJobInfo.job_name.length > 0">
                        <div class="key-style">{{$t('Job Name')}}</div>
                        <div class="value-style">{{selectedJobInfo.job_name}}</div>
                    </li>
                    <li v-if="Object.keys(selectedJobInfo.data).includes('file_uid') &&
                    !['undefined',null].includes(selectedJobInfo.data.file_uid) &&  selectedJobInfo.data.file_uid.length > 0">
                        <div class="key-style">{{$t('File Uid')}}</div>
                        <div class="value-style">{{selectedJobInfo.data.file_uid}}</div>
                    </li>
                    <li v-if="Object.keys(selectedJobInfo).includes('data') &&
                    !['undefined',null].includes(selectedJobInfo.data) &&  Object.keys(selectedJobInfo.data).length > 0">
                        <div class="key-style">{{$t('File Name')}}</div>
                        <div class="value-style" style="overflow-wrap: anywhere;" v-if="'slug_name' in selectedJobInfo.data && selectedJobInfo.data.slug_name">{{selectedJobInfo.data.slug_name}}</div>
                        <div class="value-style" style="overflow-wrap: anywhere;" v-else>{{'resource_name' in selectedJobInfo.data? selectedJobInfo.data.resource_name : '-'}}</div>
                    </li>
                    <template v-if="Object.keys(selectedJobInfo.data).includes('dst_path')">
                      <li v-if="Object.keys(selectedJobInfo.data).includes('src_path') &&
                            selectedJobInfo.data.src_path &&  selectedJobInfo.data.src_path.length > 0">
                          <div class="key-style">{{$t('File Path')}}</div>
                          <div class="value-style" style="overflow-wrap:anywhere">{{selectedJobInfo.data.src_path}}</div>
                      </li>
                      <li v-if="selectedJobInfo.data.dst_path &&  selectedJobInfo.data.dst_path.length > 0">
                          <div class="key-style">{{$t('Dst. Path')}}</div>
                          <div class="value-style" style="overflow-wrap:anywhere">{{selectedJobInfo.data.dst_path}}</div>
                      </li>
                    </template>
                    <li v-else-if="Object.keys(selectedJobInfo.data).includes('path') &&
                      !['undefined',null].includes(selectedJobInfo.data.path) &&  selectedJobInfo.data.path.length > 0">
                        <div class="key-style">{{$t('Path')}}</div>
                        <div class="value-style" style="overflow-wrap:anywhere">{{selectedJobInfo.data.path}}</div>
                    </li>
                    <li v-if="Object.keys(selectedJobInfo).includes('created_datetime') &&
                    !['undefined',null].includes(selectedJobInfo.created_datetime) &&  selectedJobInfo.created_datetime.length > 0">
                        <div class="key-style">{{$t('Created Time')}}</div>
                        <div class="value-style" style="overflow-wrap:anywhere">{{getDateAndTimeInConfiguredFormat(selectedJobInfo.created_datetime)}}</div>
                    </li>
                    <li v-if="Object.keys(selectedJobInfo.data).includes('size') &&
                    !['undefined',null].includes(selectedJobInfo.data.size) &&  selectedJobInfo.data.size.length > 0">
                        <div class="key-style">{{$t('Size')}}</div>
                        <div class="value-style" style="overflow-wrap:anywhere">{{humaniseSize(selectedJobInfo.data.size)}}</div>
                    </li>
                    <li v-if="Object.keys(selectedJobInfo).includes('node_id') &&
                    !['undefined',null].includes(selectedJobInfo.node_id) &&  selectedJobInfo.node_id.length > 0">
                        <div class="key-style">{{$t('Node ID')}}</div>
                        <div class="value-style" style="overflow-wrap:anywhere">{{selectedJobInfo.node_id}}</div>
                    </li>
                    <li v-if="Object.keys(selectedJobInfo).includes('job_worker') && selectedJobInfo.job_worker &&
                      selectedJobInfo.job_worker.length > 0">
                        <div class="key-style">{{$t('Worker')}}</div>
                        <div class="value-style" style="overflow-wrap:anywhere">{{selectedJobInfo.job_worker}}</div>
                    </li>
                    <li v-if="selectedJobInfo.error_message && selectedJobInfo.error_message.length > 0">
                        <div class="key-style">{{$t('Error description')}}</div>
                        <div class="value-style" style="overflow-wrap:anywhere">{{selectedJobInfo.error_message}}</div>
                    </li>
                    <li v-if="!['undefined',null].includes(categoryDetails.name) && categoryDetails.name.length > 0">
                        <div class="key-style">{{$t('Catalogs')}}</div>
                        <div class="value-style" style="overflow-wrap:anywhere">{{categoryDetails.name}}</div>
                    </li>
                    <!-- <li v-if="selectedJobInfo.data.server.length > 0">
                        <div class="key-style">Server</div>
                        <div class="value-style">{{selectedJobInfo.data.server}}</div>
                    </li> -->
                    <li>
                      <div class="key-style">{{$t('User name')}}</div>
                      <div class="value-style">{{getUserNameFromId(selectedJobInfo.user_id)}}</div>
                    </li>
                    <li>
                        <div class="key-style">{{$t('Status')}}</div>
                        <div class="value-style" :style='getColorToState(selectedJobInfo.state)'>{{selectedJobInfo.state}}</div>
                    </li>
                </ul>
              </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue"
import Utils from "../../components.utils";
import {mapActions } from "vuex";

export default {
    props:["selectedJobInfo","jobId","userMap"],
    data(){
        return{
        activeIndex :null,
        activeIndexInfo:{},
        binIdList: [],
        categoryDetails:{name:"",id:""},
        }
    },
    components:{
        'cancel-icon':cancelIcon
    },
    created(){
      try {
        if(this.jobId){
          this.getJobInfoFromServer({params:{jobId:this.jobId}}).then((data) => {
            this.selectedJobInfo = data.job;
          })
        }
        else if (Object.keys(this.selectedJobInfo.data).includes('metadata') && Object.keys(this.selectedJobInfo.data.metadata).includes('category_id') && !['undefined',null].includes(this.selectedJobInfo.data.metadata.category_id) && this.selectedJobInfo.data.metadata.category_id.length > 0){
          this.updateRoute(this.selectedJobInfo.data.metadata.category_id);
        }
      } catch (error) {
        console.log("[Catalog not found to display]")
      }
    },
    methods: {
      updateRoute(categoryId){
          if(categoryId.trim().length <= 0){
            return
          }
          this.getCategoryTreefromId({ params: { catalog_id:categoryId,asset_type:"catalog"}}).then((route)=>{
            let catalogPath = route
            let catalogPathList = catalogPath.split(" > ")
            this.categoryDetails.name = (catalogPathList[catalogPathList.length - 1] + " [ " + route + "] ")
            this.route = route
         })
        },
      humaniseSize(bytes){
        let data = Utils.humanizeSize(bytes)
        return `${data["value"]} ${data["unit"]}`
      },
      getUserNameFromId(userId){
        let userInfoList = this.userMap.filter(map => map.user_id == userId)
        if(userInfoList.length > 0){
          return userInfoList[0].username;
        }
        return ""
      },
      close(){
        this.$emit('close')
      },
      getColorToState(state){
        if (state == "COMPLETED") return {'color':'green'}; if (state == "FAILED" || state == "ABORTED") return {'color':'#cc6464'}; if (state == "QUEUED") return {'color':'orange'}; if (state == "IN_PROGRESS") return {'color':'orange'};
      },
    ...mapActions("jobs", ["getJobInfoFromServer"]),
    ...mapActions("assets",["getCategoryTreefromId"])
    },
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
    max-width: 800px;
    width: 800px;
    height: 500px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      overflow: auto;
      user-select: text !important; 
      cursor:text;
    }
  }

/* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }
    
.modal {
  text-align: center;
  padding: 0!important;
  display:block;
  position: fixed;
  inset-inline-start: 0px;
  top: 8%;
}
.modal:before {
  content: '';
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
      padding: 2%;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:1%;
    justify-content: flex-start;
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:17%;
            text-align: start;
        }
        .value-style{
            color: $text-color;
            width: 70%;
            text-align: start;
            margin-inline-start: 11px;
            word-break: break-all;
        }
    }
}
</style>